export default __webpack_public_path__ + "static/media/bgAsset2.aec70722.svg";